/* acc_toddla_lp_01_01: reveal and count-up on scroll, sticky CTA bar, placeholders for missing Files images. */
/* No scroll listeners: observers drive everything, and one rAF loop runs only while numbers count. */
(function () {
  'use strict';

  var ROOT = '.td01';
  var teardowns = new WeakMap();
  var hasIO = 'IntersectionObserver' in window;
  var calm =
    !!(window.Shopify && window.Shopify.designMode) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Blocks fade in as a whole; cards inside the moments and reviews blocks fade in one by one.
  var REVEAL = [
    '.td01-blk:not(.td01-article-header):not(.td01-moments):not(.td01-reviews)',
    '.td01-moment',
    '.td01-reviews__rating',
    '.td01-reviews__card',
    '.td01-reviews__tcard'
  ].join(',');
  var COUNT = '.td01-stats__figure, .td01-stat-banner__figure';
  var COUNT_MS = 1400;
  var NUM = /^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/;

  /* ------------------------------------------------ missing Files images */
  function toPlaceholder(img) {
    if (!img.parentNode) return;
    var ph = document.createElement('div');
    var span = document.createElement('span');
    ph.className = img.className + ' td01-media-ph';
    ph.setAttribute('role', 'img');
    ph.setAttribute('aria-label', img.alt || img.getAttribute('data-td01-note') || '');
    span.textContent = img.getAttribute('data-td01-note') || '';
    ph.appendChild(span);
    img.replaceWith(ph);
  }

  // Capture phase: image errors do not bubble.
  document.addEventListener(
    'error',
    function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.hasAttribute('data-td01-file')) toPlaceholder(t);
    },
    true
  );

  function initMedia(root) {
    root.querySelectorAll('img[data-td01-file]').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) toPlaceholder(img);
    });
  }

  /* ------------------------------------------- read phase (one layout) */
  // Everything already on screen at load is left alone, so nothing above the fold flickers.
  function plan(root) {
    var fold = window.innerHeight;
    var reveal = [];
    var count = [];
    if (!hasIO || calm) return { reveal: reveal, count: count };

    if (root.hasAttribute('data-td01-reveal')) {
      var rows = new Map();
      root.querySelectorAll(REVEAL).forEach(function (el) {
        var top = Math.round(el.getBoundingClientRect().top);
        if (top < fold * 0.9) return;
        var row = rows.get(el.parentNode) || { top: null, n: 0 };
        row.n = row.top === top ? row.n + 1 : 0;
        row.top = top;
        rows.set(el.parentNode, row);
        reveal.push({ el: el, delay: row.n * 90 });
      });
    }

    if (root.hasAttribute('data-td01-count')) {
      root.querySelectorAll(COUNT).forEach(function (el) {
        var text = el.textContent.trim();
        var m = NUM.exec(text);
        if (!m || el.getBoundingClientRect().top < fold) return;
        count.push({
          el: el,
          text: text,
          pre: m[1],
          suf: m[3],
          to: parseFloat(m[2].replace(/,/g, '')),
          dec: (m[2].split('.')[1] || '').length,
          commas: m[2].indexOf(',') > -1,
          last: ''
        });
      });
    }
    return { reveal: reveal, count: count };
  }

  /* ---------------------------------------------------- reveal on scroll */
  function startReveal(root, items, off) {
    if (!items.length) return;
    items.forEach(function (it) {
      it.el.classList.add('td01-reveal');
      if (it.delay) it.el.style.setProperty('--td01-reveal-delay', it.delay + 'ms');
    });
    root.classList.add('td01--reveal');

    // top < 0 too: an anchor jump or restored scroll skips past items without intersecting them.
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    items.forEach(function (it) {
      io.observe(it.el);
    });
    off.push(function () {
      io.disconnect();
    });
  }

  /* ------------------------------------------------------------ count-up */
  function fmt(job, value) {
    var parts = value.toFixed(job.dec).split('.');
    if (job.commas) parts[0] = parts[0].replace(/\B(?=(\d{3})+$)/g, ',');
    return job.pre + parts.join('.') + job.suf;
  }

  function startCount(jobs, off) {
    if (!jobs.length) return;
    var byEl = new Map();
    var running = [];
    var frame = 0;

    // Only textContent is written per frame, and only when the shown value changes.
    function step(now) {
      frame = 0;
      for (var i = running.length - 1; i >= 0; i--) {
        var job = running[i];
        if (job.t0 === undefined) job.t0 = now;
        var p = Math.min(1, (now - job.t0) / COUNT_MS);
        if (p === 1) {
          job.el.textContent = job.text;
          running.splice(i, 1);
          continue;
        }
        var v = job.to * (1 - Math.pow(1 - p, 4));
        var s = fmt(job, job.dec ? v : Math.floor(v));
        if (s !== job.last) {
          job.el.textContent = s;
          job.last = s;
        }
      }
      if (running.length) frame = window.requestAnimationFrame(step);
    }

    jobs.forEach(function (job) {
      byEl.set(job.el, job);
      job.el.textContent = fmt(job, 0);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
          io.unobserve(e.target);
          var job = byEl.get(e.target);
          if (!e.isIntersecting) {
            job.el.textContent = job.text;
            return;
          }
          running.push(job);
          if (!frame) frame = window.requestAnimationFrame(step);
        });
      },
      { threshold: 0.6 }
    );
    jobs.forEach(function (job) {
      io.observe(job.el);
    });
    off.push(function () {
      io.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      jobs.forEach(function (job) {
        job.el.textContent = job.text;
      });
    });
  }

  /* ---------------------------------------------------------- sticky bar */
  function initSticky(root, off) {
    var bar = root.querySelector('[data-td01-sticky]');
    if (!bar) return;
    var start = root.querySelector('[data-td01-sticky-start]') || root.querySelector('.td01-blk');
    var past = false;
    var blocked = new Set();
    var shown = null;
    var height = -1;

    // DOM is written only when the state actually changes.
    function render() {
      var show = past && !blocked.size;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      root.classList.toggle('td01--bar-space', show);
    }

    // On <html>, so the theme's scroll-to-top button can read it too.
    function measure() {
      var h = bar.offsetHeight;
      if (h === height) return;
      height = h;
      document.documentElement.style.setProperty('--td01-sticky-h', h + 'px');
    }

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      ro.observe(bar);
      off.push(function () {
        ro.disconnect();
      });
    } else {
      measure();
    }

    if (!hasIO || !start) {
      past = true;
      render();
      return;
    }

    // An observer reports every crossing and the first state after a jump or restored scroll.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === start) past = !e.isIntersecting && e.boundingClientRect.top < 0;
        else if (e.isIntersecting) blocked.add(e.target);
        else blocked.delete(e.target);
      });
      render();
    });
    io.observe(start);
    root.querySelectorAll('[data-td01-sticky-stop]').forEach(function (el) {
      io.observe(el);
    });
    off.push(function () {
      io.disconnect();
    });
  }

  /* ------------------------------------------------- theme scroll-to-top */
  // Hidden by CSS on this page; its global handler would still run on every scroll, so detach it.
  function muteScrollTop(root, off) {
    var fn = window.checkBtnVisibility;
    if (!root.hasAttribute('data-td01-no-scroll-top') || typeof fn !== 'function') return;
    window.removeEventListener('scroll', fn);
    off.push(function () {
      window.addEventListener('scroll', fn);
    });
  }

  /* ---------------------------------------------------------------- boot */
  function init(scope) {
    var roots = scope.matches && scope.matches(ROOT) ? [scope] : scope.querySelectorAll(ROOT);
    var queue = [];
    // Read every root first, then write, so the whole page costs one forced layout.
    Array.prototype.forEach.call(roots, function (root) {
      if (teardowns.has(root)) return;
      var off = [];
      teardowns.set(root, off);
      queue.push({ root: root, off: off, plan: plan(root) });
    });
    queue.forEach(function (q) {
      initMedia(q.root);
      muteScrollTop(q.root, q.off);
      startReveal(q.root, q.plan.reveal, q.off);
      startCount(q.plan.count, q.off);
      initSticky(q.root, q.off);
    });
  }

  function destroy(scope) {
    scope.querySelectorAll(ROOT).forEach(function (root) {
      (teardowns.get(root) || []).forEach(function (fn) {
        fn();
      });
      teardowns.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if (!window.td01Bound) {
    window.td01Bound = true;
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      destroy(e.target);
    });
  }
})();
